import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import {
  ContractorLegalBankDetail,
  ContractorLegalItem,
  ContractorLegalSearch,
  ContractorLegalSearchBankRequest,
  ContractorLegalSearchInnRequest,
} from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getContractorLegalDetail: builder.query<ContractorLegalItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorLegal/${data.id}`,
      }),
      providesTags: ['contractorLegal'],
    }),
    changeContractorLegal: builder.mutation<void, ContractorLegalItem>({
      query: (data) => ({
        url: `/v1/ContractorLegal/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['contractorLegal'],
    }),
    createContractorLegal: builder.mutation<void, Omit<ContractorLegalItem, 'id'>>({
      query: (data) => ({
        url: '/v1/ContractorLegal',
        method: 'POST',
        body: data,
      }),
    }),
    deleteContractorLegal: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorLegal/${data.id}`,
        method: 'DELETE',
      }),
    }),
    getContractorLegalSearch: builder.query<ContractorLegalSearch, ContractorLegalSearchInnRequest>({
      query: (data) => ({
        url: `/v1/ContractorLegal/search/${data.inn}`,
      }),
    }),
    getContractorLegalSearchBankDetails: builder.query<ContractorLegalBankDetail, ContractorLegalSearchBankRequest>({
      query: (data) => ({
        url: `/v1/ContractorLegal/SearchBankDetails/${data.bik}`,
      }),
    }),
  }),
});

export const {
  useChangeContractorLegalMutation,
  useCreateContractorLegalMutation,
  useDeleteContractorLegalMutation,
  useGetContractorLegalDetailQuery,
  useGetContractorLegalSearchBankDetailsQuery,
  useGetContractorLegalSearchQuery,
  useLazyGetContractorLegalDetailQuery,
  useLazyGetContractorLegalSearchBankDetailsQuery,
  useLazyGetContractorLegalSearchQuery,
} = request;
